module.exports = __webpack_public_path__ + "static/img/qcsh4.26c01f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qcsh4.jpg
// module id = WUM+
// module chunks = 0